/* eslint-disable @typescript-eslint/no-explicit-any */
import { services } from '../services/hub.service';

interface RegistryResponse {
  data: {
    data: any;
    [key: string]: any;
  };
}

interface Params {
  [key: string]: any;
}

export const registryActions = {
  getEntries,
  getEntryById,
  addEntry,
  updateEntry,
  deleteEntry,
  getTags,
  addTag,
  deleteTag,
};

function unwrap(promise: any, context: string): any {
  if (promise && 'data' in promise) return promise.data;
  console.log(`error in actions ${context}`);
  return Promise.reject(`Error: ${context}`);
}

function getEntries(): Promise<any> {
  return services
    .get<RegistryResponse>(`/registry/list?limit=500`)
    .then((p) => unwrap(p, 'get registry'));
}

function getEntryById(id: string | number): Promise<any> {
  return services.get<RegistryResponse>(`/registry/${id}`).then((p) => unwrap(p, 'get entry'));
}

function addEntry(params: Params): Promise<any> {
  return services.post<RegistryResponse>(`/registry/add`, params).then((p) => unwrap(p, 'add entry'));
}

function updateEntry(id: string | number, params: Params): Promise<any> {
  return services
    .put<RegistryResponse>(`/registry/update/${id}`, params)
    .then((p) => unwrap(p, 'update entry'));
}

function deleteEntry(id: string | number): Promise<any> {
  return services
    .delete<RegistryResponse>(`/registry/delete/${id}`)
    .then((p) => unwrap(p, 'delete entry'));
}

function getTags(): Promise<any> {
  return services.get<RegistryResponse>(`/registry/tags/list`).then((p) => unwrap(p, 'get tags'));
}

function addTag(params: Params): Promise<any> {
  return services
    .post<RegistryResponse>(`/registry/tags/add`, params)
    .then((p) => unwrap(p, 'add tag'));
}

function deleteTag(id: string | number): Promise<any> {
  return services
    .delete<RegistryResponse>(`/registry/tags/delete/${id}`)
    .then((p) => unwrap(p, 'delete tag'));
}
